/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Security_Enable_Two_Factor_ButtonInputs */

const en_security_enable_two_factor_button = /** @type {(inputs: Security_Enable_Two_Factor_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable 2FA`)
};

const es_security_enable_two_factor_button = /** @type {(inputs: Security_Enable_Two_Factor_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar 2FA`)
};

/**
* | output |
* | --- |
* | "Enable 2FA" |
*
* @param {Security_Enable_Two_Factor_ButtonInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const security_enable_two_factor_button = /** @type {((inputs?: Security_Enable_Two_Factor_ButtonInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Security_Enable_Two_Factor_ButtonInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_security_enable_two_factor_button(inputs)
	return es_security_enable_two_factor_button(inputs)
});